import React from "react"

import { StaticQuery, graphql } from "gatsby"

import { Context } from "../utility/context"
import { postMessageContentHeight } from "../utility/post-message"

import Menu from "../components/block/menu"
import Header from "../components/block/header"
import Overview from "../components/block/overview"
import MovementsForecasts from "../components/block/movements-forecasts"
import IndustrySim from "../components/block/industry-sim"
import Misc from "../components/block/misc/misc"

import "../style/index.css"

import linkedin from "../assets/icons/linkedin.png"
import twitter from "../assets/icons/twitter.png"
import mail from "../assets/icons/mail.png"

class IndexPage extends React.Component {
  state = {
    quarterlyEdition: null,
    monthlyEdition: null,
    animate: false,
    visibility: {
      scroll: 0,
      height: 0,
    }
  }

  componentDidMount() {
    setTimeout(
      () => {
        this.setState({
          animate: true,
        })
        postMessageContentHeight(document.getElementById("iframe-root").scrollHeight)
      },
      1000
    )

    if (window.location !== window.parent.location) {
      window.addEventListener("message", (event) => {
        if (typeof event === "object") {
          this.setState({
            visibility: event.data,
          });
        }
      }, false);
    } else {
      window.addEventListener("scroll", (event) => {
        this.setState({
          visibility: {
            scroll: 0,
            height: window.innerHeight,
          },
        });
      });
    }
  }

  share = (type) => {
    switch (type) {
      case "twitter":
        return window.open("https://twitter.com/home?status=" + window.location.href, "twitter-popup", "height=600,width=900");
      case "linkedin":
        return window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href, "linkedin-popup", "height=600,width=900");
      default:
        return;
    }
  };

  getShareUrl = () => {
    if (typeof window !== "undefined") {
      return window.location.href;
    }
  }

  parseAllGoogleSpreadsheetQuarterlyIndustrySim = (edition, data) => {
    return data.slice(1, data.length).map((node) => ({
      industry: node.industry,
      value: node[edition.split(" ")[0].toLowerCase()],
    }));
  }

  parseAllGoogleSpreadsheetQuarterlyIndustryBreakdown = (edition, data) => {
    return data.slice(1, data.length).map((node) => ({
      industry: node.industry,
      bucket: node.bucket,
      value: node[edition.split(" ")[0].toLowerCase()],
    }));
  }

  parseAllGoogleSpreadsheetMonthlyMisc = (edition, data) => {
    return data.slice(1, data.length).map((node) => ({
      type: node.type,
      title: node.title,
      value: parseFloat(node[edition.split(" ")[0].toLowerCase()]),
    }));
  }

  parseGraphQlData = (data) => {
    const quarterlyEditions = data.allGoogleSpreadsheetEditions.edges.map((edge) => edge.node.quarterly).filter((edition) => edition);
    const monthlyEditions = data.allGoogleSpreadsheetEditions.edges.map((edge) => edge.node.monthly).filter((edition) => edition);

    const navigationLinks = data.allGoogleSpreadsheetTopNavHistoryFiles.edges.map((edge) => edge.node);

    const quarterlyData = quarterlyEditions.map((edition) => ({
      edition: edition,
      block: data.allGoogleSpreadsheetQuarterlyBlock.edges.map((edge) => edge.node).filter((node) => node.edition === edition),
      industrySim: this.parseAllGoogleSpreadsheetQuarterlyIndustrySim(edition, data.allGoogleSpreadsheetQuarterlyIndustrySim.edges.map((edge) => edge.node)),
      industryBreakdown: this.parseAllGoogleSpreadsheetQuarterlyIndustryBreakdown(edition, data.allGoogleSpreadsheetQuarterlyIndustryBreakdown.edges.map((edge) => edge.node))
    }));

    const monthlyData = monthlyEditions.map((edition) => ({
      edition: edition,
      header: data.allGoogleSpreadsheetTitleBlock.edges.map((edge) => edge.node).find((node) => node.edition === edition),
      block: data.allGoogleSpreadsheetMonthlyBlock.edges.map((edge) => edge.node).filter((node) => node.edition === edition),
      misc: this.parseAllGoogleSpreadsheetMonthlyMisc(edition, data.allGoogleSpreadsheetMonthlyMisc.edges.map((edge) => edge.node)),
    }));

    const selectedQuarterlyEdition = this.state.quarterlyEdition || quarterlyEditions[0];
    const selectedMonthlyEdition = this.state.monthlyEdition || monthlyEditions[0];

    return {
      navigationLinks: navigationLinks,
      selected: {
        quarterly: quarterlyData.find((quarterlyEdition) => quarterlyEdition.edition === selectedQuarterlyEdition),
        monthly: monthlyData.find((monthlyEdition) => monthlyEdition.edition === selectedMonthlyEdition),
      },
      editions: {
        quarterly: quarterlyEditions,
        monthly: monthlyEditions,
      },
      editionData: {
        quarterly: quarterlyData,
        monthly: monthlyData,
      },
    };
  }

  render() {
    return (
      <div id="iframe-root" style={{ overflow: "scroll" }}>
        <StaticQuery
          query={graphql`
            query {
              site {
                siteMetadata {
                  title
                }
              }
              allGoogleSpreadsheetEditions {
                edges {
                  node {
                    quarterly
                    monthly
                  }
                }
              }
              allGoogleSpreadsheetTopNavHistoryFiles {
                edges {
                  node {
                    menu
                    link
                  }
                }
              }
              allGoogleSpreadsheetTitleBlock {
                edges {
                  node {
                    edition
                    title
                    content
                    link1
                    link2
                  }
                }
              }
              allGoogleSpreadsheetQuarterlyBlock {
                edges {
                  node {
                    edition
                    type
                    title
                    content
                    percentage
                    link1
                  }
                }
              }
              allGoogleSpreadsheetQuarterlyIndustrySim {
                edges {
                  node {
                    industry
                    q1
                    q2
                    q3
                    q4
                  }
                }
              }
              allGoogleSpreadsheetQuarterlyIndustryBreakdown {
                edges {
                  node {
                    industry
                    bucket
                    q1
                    q2
                    q3
                    q4
                  }
                }
              }
              allGoogleSpreadsheetMonthlyBlock {
                edges {
                  node {
                    edition
                    type
                    title
                    content
                    link1
                  }
                }
              }
              allGoogleSpreadsheetMonthlyMisc {
                edges {
                  node {
                    type
                    title
                    january
                    february
                    march
                    april
                    may
                    june
                    july
                    august
                    september
                    october
                    november
                    december
                  }
                }
              }
            }
          `}
          render={graphqlData => {
            const parsedData = this.parseGraphQlData(graphqlData);

            return (
              <Context.Provider
                value={{
                  visibility: this.state.visibility,

                  navigationLinks: parsedData.navigationLinks,

                  selected: parsedData.selected,

                  editions: parsedData.editions,
                  editionData: parsedData.editionData,

                  changeEdition: {
                    quarterly: (edition) => this.setState({ quarterlyEdition: edition, }),
                    monthly: (edition) => this.setState({ monthlyEdition: edition, }),
                  },
                }}
              >
                <Context.Consumer>
                  {context => (
                    <React.Fragment>
                      <Menu />
                      <div className="col col-12 mb2">
                        <div className="md-col-10 lg-col-7 mx-auto pt1 px2 pb0 white center">
                          <h1 style={{ fontSize: "58px" }} className={`thin`}>
                            Remuneration Trends & Insights
                          </h1>
                          <p className={`regular subtitle`}>
                            Bringing you the most up-to-date information on remuneration
                            trends and insights on the current rewards environment, key
                            economic data affecting pay decisions, topical HR issues and
                            more!
                          </p>
                        </div>
                        <div className="md-col-10 mx-auto white flex flex-justify-end flex-center" >
                          <div className="bold mr2">Share</div>
                          <a href={`https://www.linkedin.com/company/mercer-australia/`} className="right mr1 pointer"><div className="social-icon" style={{backgroundImage: `url(${linkedin})`}}/></a>
                          <a href={`https://twitter.com/mercerau`} className="right mr1 pointer"><div className="social-icon" style={{backgroundImage: `url(${twitter})`}}/></a>
                          <a href={`mailto:?subject=Share&body=${this.getShareUrl()}`} className={`right pointer`}><div className={`social-icon`} style={{backgroundImage: `url(${mail})`}}/></a>
                        </div>
                        <div className="md-col-10 lg-col-10 mx-auto p1">
                          <Header />
                          <div id="quarterly" className="col col-12">
                            <Overview 
                              blockOverview={
                                context.selected.quarterly.block.find(
                                  data => data.type === "overview"
                                )
                              }
                              blockLastUpdated={
                                context.selected.quarterly.block.find(
                                  data => data.type === "last-updated"
                                )
                              }
                              type="quarterly"
                            />
                          </div>
                          <MovementsForecasts
                            animate={this.state.animate}
                            blockMovement={
                              context.selected.quarterly.block.find(
                                data => data.type === "movement"
                              )
                            }
                            blockForecast={
                              context.selected.quarterly.block.find(
                                data => data.type === "forecast"
                              )
                            }
                          />
                          <IndustrySim
                            animate={this.state.animate}
                            blockIndustrySim={
                              context.selected.quarterly.block.find(
                                data => data.type === "industry-sim"
                              )
                            }
                            data={{
                              overview: context.selected.quarterly.industrySim,
                              detailed: context.selected.quarterly.industryBreakdown,
                            }}
                          />
                          <div id="monthly" className="col col-12">
                            <Overview 
                              blockOverview={
                                context.selected.monthly.block.find(
                                  data => data.type === "overview"
                                )
                              }
                              blockLastUpdated={
                                context.selected.monthly.block.find(
                                  data => data.type === "last-updated"
                                )
                              }
                              type="monthly"
                            />
                          </div>
                          <Misc
                            animate={this.state.animate}
                            blocks={{
                              barometer: context.selected.monthly.block.find(
                                edge => edge.type === "misc-barometer"
                              ),
                              genderPayIndex: context.selected.monthly.block.find(
                                edge => edge.type === "misc-gender-pay-index"
                              ),
                              remunerationSentimentIndex: context.selected.monthly.block.find(
                                edge =>
                                  edge.type === "misc-remuneration-sentiment-index"
                              ),
                              newHirePayRates: context.selected.monthly.block.find(
                                edge => edge.type === "misc-new-hire-pay-rates"
                              ),
                              gdp: context.selected.monthly.block.find(
                                edge => edge.type === "misc-gdp"
                              ),
                              cpi: context.selected.monthly.block.find(
                                edge => edge.type === "misc-cpi"
                              ),
                              wpi: context.selected.monthly.block.find(
                                edge => edge.type === "misc-wpi"
                              ),
                              unemployment: context.selected.monthly.block.find(
                                edge => edge.type === "misc-unemployment"
                              ),
                              keyEconomicIndicators: context.selected.monthly.block.find(
                                edge =>
                                  edge.type === "misc-key-economic-indicators"
                              ),
                            }}
                            data={{
                              barometer: {
                                contraction: context.selected.monthly.misc.find(
                                  edge => edge.type === "barometer-contraction"
                                ),
                                stable: context.selected.monthly.misc.find(
                                  edge => edge.type === "barometer-stable"
                                ),
                                expansion: context.selected.monthly.misc.find(
                                  edge => edge.type === "barometer-expansion"
                                ),
                              },
                              genderPayIndex: context.selected.monthly.misc.find(
                                edge => edge.type === "gender-pay-index"
                              ),
                              remunerationSentimentIndex: context.selected.monthly.misc.find(
                                edge =>
                                  edge.type === "remuneration-sentiment-index"
                              ),
                              newHirePayRates: context.selected.monthly.misc.find(
                                edge => edge.type === "new-hire-pay-rates"
                              ),
                              gdp: context.selected.monthly.misc.find(
                                edge => edge.type === "gdp"
                              ),
                              cpi: context.selected.monthly.misc.find(
                                edge => edge.type === "cpi"
                              ),
                              wpi: context.selected.monthly.misc.find(
                                edge => edge.type === "wpi"
                              ),
                              unemployment: context.selected.monthly.misc.find(
                                edge => edge.type === "unemployment"
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </Context.Consumer>
              </Context.Provider>
            )
          }}
        />
      </div>
    )
  }
}

export default IndexPage
